<template>
  <div>
    <div class="min-h-[310px]">
      <component :is="LoginMethods.get(currentLoginMethod)?.component"></component>
    </div>
    <div class="mb-3 flex items-center justify-center">
      <span class="grow h-px bg-divider"></span>
      <span class="mx-3 text">或者</span>
      <span class="grow h-px bg-divider"></span>
    </div>
    <div class="grid gap-4 mb-6">
      <button v-for="method in otherLoginMethods" :key="method" @click="onClickChangeLoginMethod(method)" class="login-method-button">
        <img :src="LoginMethods.get(method)?.icon" :alt="LoginMethods.get(method)?.name">
        <span>{{ LoginMethods.get(method)?.name }}</span>
      </button>
      <button class="login-method-button col-span-1 sm:col-span-2" @click="onClickLoginWithGitHub">
        <img :src="GitHubIcon" alt="GitHub 登录">
        <span>GitHub 登录</span>
      </button>
    </div>
    <p class="text-center text-secondary-text text-xs">登录即代表同意和鲸平台<a href="/static/terms.html" target="_blank" class="text-sub-color">《用户协议》</a>、<a href="/static/privacy.html" target="_blank" class="text-sub-color">《隐私保护指引》</a></p>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import getQueryObject from '@/utils/get-query-object'
import trackEvent from '@/utils/track-event'
import LoginWithWeChat from '@/components/login-page/login-with-wechat.vue'
import LoginWithMessage from '@/components/login-page/login-with-message.vue'
import LoginWithPassword from '@/components/login-page/login-with-password.vue'
// TODO svg loader
// @ts-ignore
import WeChatIcon from '@/assets/login-page/wechat.svg'
// @ts-ignore
import MessageIcon from '@/assets/login-page/message.svg'
// @ts-ignore
import PasswordIcon from '@/assets/login-page/password.svg'
// @ts-ignore
import GitHubIcon from '@/assets/login-page/github.svg'

const LoginMethods = new Map()
LoginMethods.set('wechat', { name: '微信登录', icon: WeChatIcon, component: LoginWithWeChat })
LoginMethods.set('message', { name: '短信登录', icon: MessageIcon, component: LoginWithMessage })
LoginMethods.set('password', { name: '密码登录', icon: PasswordIcon, component: LoginWithPassword })

const currentLoginMethod = ref('wechat')
const otherLoginMethods = computed(() => Array.from(LoginMethods.keys()).filter(key => key !== currentLoginMethod.value))

const onClickChangeLoginMethod = (method: string) => currentLoginMethod.value = method

const onClickLoginWithGitHub = () => {
  trackEvent('click_register', 'github', 'community');
  let url = '/oauth/portal/github';
  const queries = getQueryObject()
  if (queries.redirect) {
    url = url + '?redirect=' + encodeURIComponent(queries.redirect);
  }
  window.location.replace(url);
}
</script>

<style lang="scss" scoped>
.login-method-button {
  border: 1px solid $border;
  border-radius: 24px;
  height: 44px;
  padding: 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-right: 8px;
  }
  span {
    font-size: 16px;
  }
}
</style>
